export const EL_MEDIHA = [
  {
    id: "em001",
    metin: "{{ad}}, bu ele baktım ve içim sıkıştı biraz. Ama merak etme — bu çizgiler güçlü bir insan anlatıyor. {{soru}} konusunda şunu söyleyeyim: elindeki o derin çizgi, hayatında büyük bir dönüm noktasına yaklaştığını gösteriyor. Bu dönem seni zorlayabilir, ama zor dönemler boşuna gelmez.\n\nHazır ol. Dönüm noktaları hem bitiş hem başlangıçtır — neyi bitirip neyi başlatacağını sen belirlersin. Bu el bana kararlı bir ruh gösteriyor. O kararlılığı kullan.",
    tema: "donum_noktasi"
  },
  {
    id: "em002",
    metin: "{{ad}}, bu eli görünce annemin bir sözü aklıma geldi: 'El yalan söylemez.' Ve bu el çok şey söylüyor. {{soru}} konusunda şunu görüyorum: sen çok şey taşıyorsun, omuzlarında görünmeyen ama hissedilen bir yük var.\n\nO yükün hepsini taşımak zorunda değilsin. Bir kısmını bırakabilirsin — bırakmak zayıflık değil, akıllılık. Hangi yükler gerçekten senin, hangileri başkalarından devraldığın? O ayrımı yap.",
    tema: "birakma"
  },
  {
    id: "em003",
    metin: "{{ad}}, şu baş parmağının dibine bak. Orada güçlü bir irade çizgisi var — ince ama derin. {{soru}} konusunda kararsız görünsen de, içinde güçlü bir irade saklı.\n\nO iradeyi bul ve kullan. Bazen en güçlü irade, en sessiz olanda saklıdır. Gürültülü olmak zorunda değilsin — kararlı olmak yeterli. Bir karar ver ve o karara sadık kal.",
    tema: "irade"
  },
  {
    id: "em004",
    metin: "{{ad}}, avuç içindeki o geniş alan bereket demek — bunu görmek güzel. {{soru}} ne olursa olsun, maddi konularda sıkıntı geçici. Bu el bana kalıcı bir bolluk potansiyeli gösteriyor.\n\nAma bereket kendiliğinden kapıya gelmez — ona doğru yürümek lazım. Adımlarını at, fırsatları değerlendir, ve geldiğinde savurgan olma. Bereketin kıymetini bil.",
    tema: "bereket"
  },
  {
    id: "em005",
    metin: "{{ad}}, kalp çizgisi çok derin — bu derin bir duygusal dünya anlatıyor. {{soru}} konusunda kalbinle karar veriyorsun, ve bu çoğu zaman doğru. Ama bazen aklını da devreye almak gerekiyor.\n\nKalp pusulayı gösterir, akıl yolu çizer. İkisi birlikte çalıştığında en sağlam kararlar çıkar. Bu dengeyi kur — ne sadece kalbine ne de sadece aklına teslim ol.",
    tema: "kalp"
  },
  {
    id: "em006",
    metin: "{{ad}}, baş parmağına bak — esnek mi, katı mı? Bu esneklik, hayata uyum kapasiteni gösterir. {{soru}} konusunda esnek olmak seni kurtaracak.\n\nKatılık kırar, esneklik büker ama kırılmaz. Değişen koşullara ayak uydurabilen insan, direnen insandan çok daha ileriye gider. O esnekliği kaybetme — hem güçlü hem esnek ol.",
    tema: "esneklik"
  },
  {
    id: "em007",
    metin: "{{ad}}, bu elde uzun bir akıl çizgisi var — zeki bir insan bu. {{soru}} konusunda zekânı kullan, ama sezgini de ihmal etme.\n\nZekâ yolu gösterir, sezgi yürütür. Bazen en doğru cevap, hesaplamadan değil hissetmekten gelir. İkisini birlikte kullandığında — işte o zaman gerçekten güçlüsün.",
    tema: "zeka"
  },
  {
    id: "em008",
    metin: "{{ad}}, avuç içindeki o küçük yan çizgilere bak — bunlar yardımcı çizgiler, destek enerjisi. {{soru}} konusunda yalnız değilsin. Etrafında seni destekleyen insanlar var — belki fark etmiyorsun.\n\nGözlerini aç ve etrafına bak. Yardım bazen söylenmeden gelir — ama bazen de istenmesi gerekir. İstemekten çekinme. Güçlü insanlar da yardım ister.",
    tema: "destek"
  },
  {
    id: "em009",
    metin: "{{ad}}, bu elde sağlıkla ilgili bir mesaj var — görmezden gelemem. {{soru}} ne olursa olsun, bedenini ihmal etme. Uyku, beslenme, dinlenme — bunlar lüks değil, temel ihtiyaç.\n\nSağlam beden, güçlü zihin demektir. Bedenini dinle, şikâyetlerini ciddiye al. Küçük sorunlar zamanında ele alındığında küçük kalır. Kendine öncelik ver.",
    tema: "saglik"
  },
  {
    id: "em010",
    metin: "{{ad}}, hayat çizgisi uzun ve güçlü — dayanıklı bir ruh bu. {{soru}} konusunda ne kadar zorlanırsan zorlan, yılmayacaksın.\n\nBu el bana şunu söylüyor: sen zaten biliyorsun nasıl ayakta kalınacağını. Geçmişte defalarca kalktın, yeniden başladın. Bu sefer de kalkacaksın. Çünkü bu çizgiler düşüp kalkan, ama vazgeçmeyen birini anlatıyor.",
    tema: "dayaniklilik"
  },
  {
    id: "em011",
    metin: "{{ad}}, bu elde bir yolculuk işareti var — net görüyorum. {{soru}} konusunda bir hareket geliyor; fiziksel mi zihinsel mi tam söyleyemem, ama bir değişim rüzgarı var.\n\nHazırlan. Yolculuklar bazen zorlar, bazen dönüştürür — çoğu zaman ikisi birden. O değişime açık ol, direnme. Gidilecek yerde seni bekleyen güzel şeyler var.",
    tema: "yolculuk"
  },
  {
    id: "em012",
    metin: "{{ad}}, serçe parmağına bak — iletişim parmağı bu. Uzunsa, konuşma gücün var demek. {{soru}} konusunda sözünün gücünü kullan.\n\nDoğru zamanda, doğru kişiye söylenen doğru söz — bu dünyayı değiştirir. Söylenmesi gereken bir şey var, biliyorum. Onu söyleme vakti geldi. Kelimelerini seç, ama söyle.",
    tema: "iletisim"
  },
  {
    id: "em013",
    metin: "{{ad}}, avuç içindeki o kısa ama derin çizgi — para çizgisi bu. {{soru}} ne olursa olsun, maddi konularda iyi bir dönem geliyor.\n\nAma şunu da söyleyeyim: bu dönem kalıcı olsun istiyorsan, akıllıca harca. Bolluk gelince savurganlık değil, yatırım. Bugünün rahatlığı, yarının güvencesi olsun.",
    tema: "para"
  },
  {
    id: "em014",
    metin: "{{ad}}, kalp çizgisi ile akıl çizgisi arasındaki mesafeye bak. Dengeli görünüyor — bu iyi. {{soru}} konusunda bu dengeyi koru.\n\nDenge, hayatın en kıymetli hazinesidir. Onu kaybetmemek için sürekli dikkat ister. Bir tarafa çok yüklendiğinde öbür tarafı hatırla. Ne duygular ne de mantık tek başına yeterli — ikisi birlikte tam.",
    tema: "denge"
  },
  {
    id: "em015",
    metin: "{{ad}}, bu elde güçlü bir aşk enerjisi var — kalp çizgisinde hissediyorum. {{soru}} konusunda duygusal hayatında bir gelişme yaklaşıyor; ya yeni bir başlangıç ya da mevcut ilişkide derinleşme.\n\nKalbini koru ama kapatma. Açık kalp hem risk hem fırsat taşır — ama kapalı kalp hiçbir şey hissedemez. Risk almadan büyük güzellikler gelmez.",
    tema: "ask"
  },
  {
    id: "em016",
    metin: "{{ad}}, yüzük parmağına bak — sanat ve yaratıcılık parmağı. {{soru}} konusunda yaratıcılığını kullan. Alışılmış yollar işe yaramıyorsa, farklı bir yol dene.\n\nYaratıcılık sadece sanat değil — problem çözmedir. Farklı düşün, farklı yaklaş. İçindeki o yaratıcı ruh seni doğru kapıya götürebilir.",
    tema: "yaraticilik"
  },
  {
    id: "em017",
    metin: "{{ad}}, hayat çizgisini kesen ince bir çizgi var — bir engel işareti bu. Ama hayat çizgisi devam ediyor. {{soru}} konusunda önünde bir zorluk var, inkâr etmeyeyim.\n\nAma bu zorluk sonu değil, bir test. Ve testler geçilmek için gelir. Hayat çizgisinin devam etmesi şunu söylüyor: sen bu engeli aşacaksın. Nasıl? Adım adım, sabırla.",
    tema: "engel"
  },
  {
    id: "em018",
    metin: "{{ad}}, avuç içinin enerjisi canlı ve aktif — bu iyi bir dönemde olduğunu gösteriyor. {{soru}} konusunda enerjin yüksek, bunu hissedebiliyorum.\n\nBu enerjiyi doğru kullan. Yüksek enerji dönemleri kısa sürer — bu süre içinde en önemli adımları at. Harekete geç, bekletme.",
    tema: "enerji"
  },
  {
    id: "em019",
    metin: "{{ad}}, bu elde aile çizgisi belirgin — aile bağları güçlü demek. {{soru}} ne olursa olsun, ailenle köprüleri yıkma.\n\nEn zor anda en yakın insanlar yanında olur. Belki şu an aramızda bir mesafe var, belki küskünlük. Ama o bağı koparmak, kopmaya değmez. Bir adım at — uzlaşmak zayıflık değil, olgunluktur.",
    tema: "aile"
  },
  {
    id: "em020",
    metin: "{{ad}}, işaret parmağına bak — liderlik parmağı. {{soru}} konusunda öne çık, lider ol. Arkada bekleme zamanı geçti.\n\nLiderlik büyük unvanlar değil — doğru zamanda doğru adımı atmaktır. Sen o adımı atmaya hazırsın. Çevrendekiler de bunu bekliyor, belki söylemiyorlar ama hissediyorlar.",
    tema: "liderlik"
  },
  {
    id: "em021",
    metin: "{{ad}}, bu elde çizgiler birbirine bağlanıyor — bütünlük ve uyum işareti. {{soru}} konusunda hayatının farklı alanları birbiriyle uyum içine girecek.\n\nDağınıklık geçici, bütünlük kalıcı. O bütünlüğe doğru sabırla yürü. Her şey yerli yerine oturduğunda, bugünün karmaşası anlamlı bir mozaiğe dönüşecek.",
    tema: "butunluk"
  },
  {
    id: "em022",
    metin: "{{ad}}, hayat çizgisinin ortasındaki küçük değişim noktasını görüyorum. {{soru}} konusunda büyük bir değişim yakın — belki çoktan başlamıştır bile.\n\nDeğişimden korkmak insani. Ama değişim olmadan büyüme de olmaz. Bu dönem seni dönüştürecek — izin ver ona. Karşına çıkan yeni şeylere açık ol.",
    tema: "degisim"
  },
  {
    id: "em023",
    metin: "{{ad}}, sabır çizgisi bu elde güçlü — bunu görmek beni rahatlattı. {{soru}} konusunda sabretmek zor geliyor biliyorum. Her şeyin hemen olmasını istiyorsun.\n\nAma değerli olan her şey zaman ister. Tohumdan ağaç olmak aylar yıllar alır. Sen o tohumu ektinse, sulamaya devam et. Hasat zamanı gelecek — ve o zaman bekleyişin ne kadar değerli olduğunu anlayacaksın.",
    tema: "sabir"
  },
  {
    id: "em024",
    metin: "{{ad}}, avuç içindeki o yıldız şeklini görüyor musun? Nadir görülür bu. Şans ve bereket işareti — gerçekten nadir.\n\n{{soru}} konusunda şanslı bir dönem yaklaşıyor. Ama şans, hazırlıklı olanı bulur. Gözlerini aç, fırsatları kaçırma. Ve o şans geldiğinde — korkma, at kendini.",
    tema: "sans"
  },
  {
    id: "em025",
    metin: "{{ad}}, sunu söyleyeyim: bu el güçlü bir insanın eli. {{soru}} ne kadar ağır gelse de, bu el taşır.\n\nÇünkü bu çizgiler dayanıklı, kararlı, vazgeçmeyen birini anlatıyor. Sen o insansın. Belki bugün bunu hissedemiyorsun — ama bu el bana söylüyor. Ve eller yalan söylemez.",
    tema: "guc"
  }
];